import { useDispatch } from 'react-redux'
import { useRouter } from 'next/router'
import ErrorPage from 'next/error'
import styled from '@emotion/styled'
import { getList, getLists } from '../../sequelize/queries/lists'
import { playerLoad } from '../../redux/actions'
import { playlistFromList } from '../../lib/player'
import EmbedHeader from '../../components/EmbedHeader'
import EmbedTrack from '../../components/EmbedTrack'
import Loading from '../../components/Loading'

const embedHeaderHeight = '66px'
const EmbedList = styled.ul`
  margin: 0;
  padding: ${embedHeaderHeight} 0 0 0;
  width: 100%;
`

const ListEmbedPage = ({ list }) => {
  const dispatch = useDispatch()
  const Router = useRouter()

  if (Router.isFallback) return <Loading />
  if (!list || list.published_at == null) return <ErrorPage statusCode={404} />

  const playlist = playlistFromList(list)

  const handlePlay = (playIndex) => {
    if (playlist[playIndex].src) {
      dispatch(
        playerLoad({
          list,
          playIndex,
          playlist,
        })
      )
    } else {
      dispatch(
        refreshRelease({
          list,
          playIndex,
          playlist,
        })
      )
    }
  }

  return (
    <>
      <EmbedHeader height={embedHeaderHeight} list={list} />

      <EmbedList>
        {list.ListItems.map((track, i) => (
          <EmbedTrack
            key={track.url}
            data={track}
            listId={list.id}
            play={() => handlePlay(i)}
          />
        ))}
      </EmbedList>
    </>
  )
}

export async function getStaticPaths() {
  let lists = await getLists({
    page: 1,
    perPage: 200,
  })

  return {
    paths: lists.results.map((list) => ({ params: { slug: list.slug } })),
    fallback: true,
  }
}

export async function getStaticProps(context) {
  const { slug } = context.params
  let list = await getList({ slug })
  return {
    props: {
      list,
    },
  }
}

export default ListEmbedPage
